module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('strong', [_vm._v("CONTENTS ")])]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('span', {
    attrs: {
      "href": "#/html/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('span', {
    attrs: {
      "href": "#/html/03_Copyrigh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "href": "#/html/05_Acknowle#id0"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('h6', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "html/images/commn.jpg"
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_THE_GOLD"
    }
  }, [_vm._v("1 THE GOLDEN TICKET ")])]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('span', {
    attrs: {
      "href": "#/html/07_LION_HUN",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 LION HUNTING IN SCOTLAND ")])]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_PANTING#id7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 PANTING UP THE ENDLESS ALP OF LIFE ")])]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_SEETHING",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 SEETHING IN YORKSHIRE ")])]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_OH_FOR_A",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 OH FOR A MUSE OF FIRE! ")])]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_FREUD__A",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 FREUD, ACTUALLY ")])]), _vm._v(" "), _c('h6', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "html/images/commn.jpg"
    }
  })]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_HOW_TO_G",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("How to Get There ")])]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_FURTHER#id9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Further Reading ")])]), _vm._v(" "), _c('h6', {
    staticClass: "P29"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_PHOTO_CR",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photo Credits ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1842bf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_Contents.vue
// module id = 66
// module chunks = 0